import { useEffect } from 'react';

import useTranslations from '@/lang/useTranslations';
import { useApp } from '@/platform/app/useApp';
import { TenkoAppShellNotificationsBell } from '@/shared/components/layout/TenkoAppShellNotificationsBell';

import { useEmptyNotifications } from './emptyNotifications';
import type { UseNotificationsResult } from './notifications.types';

interface SourcedBellProps {
  useNotifications: () => UseNotificationsResult;
}

// Receives the hook as a prop and is remounted (by key) when the source
// changes, so one component instance always calls the same hook implementation.
function SourcedBell({ useNotifications }: SourcedBellProps) {
  const { translation: t } = useTranslations('global');
  const { items, unreadCount, loadList, markAsRead } = useNotifications();

  useEffect(() => {
    loadList();
  }, [loadList]);

  return (
    <TenkoAppShellNotificationsBell
      labels={{
        title: t('notifications_title'),
        emptyTitle: t('notifications_empty_title'),
      }}
      items={items}
      unreadCount={unreadCount}
      onMarkAsRead={markAsRead}
    />
  );
}

/** Header bell wired to the app's notifications source (or the empty default). */
export function NotificationsBell() {
  const source = useApp().notifications?.useNotifications;

  return source ? (
    <SourcedBell key="source" useNotifications={source} />
  ) : (
    <SourcedBell key="empty" useNotifications={useEmptyNotifications} />
  );
}
